import React from "react";
import { Link } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

import { FloatingDropdown } from "../../ui/components/FloatingDropdown";
import { useTenantContext } from "../../tenant/TenantContext";

import { ButtonMenuUser } from "./cuenta.elements";
import { accountMenuItems } from "./accountMenuItems";

export const AccountDropdown = ({ children }) => {
    const { primaryColor } = useTenantContext();
    const { signOut } = useAuthenticator((context) => [context.user]);

    return (
        <FloatingDropdown placement="bottom-start" offset={4}>
            <FloatingDropdown.Title>{children}</FloatingDropdown.Title>

            <FloatingDropdown.Items wrap={false}>
                <div
                    className="d-flex flex-column"
                    style={{ minWidth: 240, padding: "8px 10px" }}
                >
                    {accountMenuItems.map((item) => (
                        <Link
                            key={item.to}
                            to={`/cuenta/${item.to}`}
                            style={{ textDecoration: "none" }}
                        >
                            <ButtonMenuUser background={primaryColor}>
                                {item.label}
                            </ButtonMenuUser>
                        </Link>
                    ))}

                    <ButtonMenuUser className="text-danger" onClick={() => signOut()}>
                        Cerrar sesión
                    </ButtonMenuUser>
                </div>
            </FloatingDropdown.Items>
        </FloatingDropdown>
    );
};
